module.exports = __webpack_public_path__ + "img/DSH.dc297774.svg";